import { render, staticRenderFns } from "./Lgx354233218116024511.vue?vue&type=template&id=038ca3e8&"
import script from "./Lgx354233218116024511.vue?vue&type=script&lang=js&"
export * from "./Lgx354233218116024511.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports